import { NgModule } from '@angular/core';

import { TruncatePipe } from 'presentation/common/pipe/truncate.pipe';
import { UserDatePipe } from 'presentation/common/pipe/user-date.pipe';
import { UsersNamePipe } from 'presentation/common/pipe/users-name.pipe';

@NgModule({
	declarations: [UserDatePipe, UsersNamePipe, TruncatePipe],
	exports: [UserDatePipe, UsersNamePipe, TruncatePipe],
})
export class PipeModule {}
